import { supportsScrollTimeline } from "motion-dom";
export function canUseNativeTimeline(target) {
    return (typeof window !== "undefined" && !target && supportsScrollTimeline());
}
//# sourceMappingURL=can-use-native-timeline.js.map